import React from 'react'
import DatePicker from 'react-datepicker'

type DatepickerPropsTypes = React.ComponentProps<typeof DatePicker>

export const Datepicker = (props: DatepickerPropsTypes): React.ReactElement => {
  return <DatePicker {...props} />
}
